import { render } from "./IncidentsPage.vue?vue&type=template&id=03a295f7&scoped=true"
import script from "./IncidentsPage.vue?vue&type=script&lang=js"
export * from "./IncidentsPage.vue?vue&type=script&lang=js"

import "./IncidentsPage.vue?vue&type=style&index=0&id=03a295f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a295f7"]])

export default __exports__